import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import { Link, useLocation } from "react-router-dom";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useGetVendorAddressListMutation } from "../../../../store/api/purchaseorderapi";
import FormLayout from "../../../../Core/Layout/FormLayout";
import PrintModal from "../../../../Core/Print/PrintModal";
import Attachment from "../../../../utils/Attachment";
const PurchaseReciept = () => {

  const location = useLocation();
  const PurchaseData = location.state?.PurchaseId;
  const [activityboll, setactivityboll] = useState(false)
  const status = location?.state?.status
  const [finalstep, setfinalstep] = useState(false);
  const [tab, settab] = useState(1)
  const [item_Rows, setitem_Rows] = useState([]);
  const [ptype, setptype] = useState("Error")
  const [loader, setloader] = useState(true)
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [vendor, select_vendor] = useState('')
  const [vendor_address_list, setvendor_address_list] = useState([]);
  const [select_vendor_address, setselect_vendor_address] = useState({});
  const [scanInput, setScanInput] = useState("");
  const [itemList, setItemList] = useState([]);
  const { data: fulldata, isLoading } = useGetDoctypeDetailsQuery({ "doctype": "Purchase Receipt", "name": PurchaseData });
  const [getvendor_address_list_data] = useGetVendorAddressListMutation();
  const [showPrintModal, setShowPrintModal] = useState(false);


  const getVendor_Address = async () => {
    try {
      const vendorAddressApiData = await getvendor_address_list_data({ vendor: vendor })
      setvendor_address_list(vendorAddressApiData.data.result);
      setselect_vendor_address(vendorAddressApiData.data.result?.[0])
    } catch (error) {
      console.log("check error", error)
    }
  }

  useEffect(() => {
    if (isLoading == false) {
        setactivityboll(true)
      let updatedRows = fulldata.message.items.map(item => ({
        ...item,
         accepted_qty: item.qty,
        rejected_qty: 0,
        expiry_date: '',
        serial_numbers: item?.serial_no == null ? [] : item?.serial_no.split(/(?=\n)/).map(s => s.replace(/\n/, 'n'))
      }));
      setItemList(updatedRows)
      if (fulldata) {
        select_vendor(fulldata.message.supplier);
      }
    };

  }, [fulldata, isLoading])


  const handleScan = (scannedCode) => {
    setItemList(prevList => {
      let itemFound = false;
      const updatedList = prevList.map(item => {
        if (item.item_code == scannedCode) {
          itemFound = true;
          if (item.accepted_qty < item.qty) {
            return {
              ...item,
              accepted_qty: parseInt(item.accepted_qty) + 1
            };
          } else {
            setptype("Error");
            setError(`All quantities already scanned for item ${item.item_code}`);
            setShowError(true);
            return item;
          }
        }
        return item;
      });

      if (!itemFound) {
        setTimeout(() => {
          setptype("Error");
          setError(`Item ${scannedCode} not found in the list`);
          setShowError(true);
        }, 0);
      }

      return updatedList;
    });
    setTimeout(() => {
      setScanInput("");
    }, 400);
  };

  useEffect(() => {
    getVendor_Address()
  }, [vendor])



  return (

    isLoading ? "" : <>
      <FormLayout
        title="View GRN"
        breadcrumbs={[
          { label: "Inbound" },
          { label: "GRN List", url: "/inbound/grn/create-grn-receipt" }]}
        status={status}
        finalStep={finalstep}
        actionButtons={
          <>
           <p className="p-0 m-0">
                        <img src={printerimg} 
                        onClick={() => setShowPrintModal(true)} 
                         className="px-2" style={{width:'35px',cursor:'pointer'}} alt="404" />
                    </p>
          </>
        }
      ></FormLayout>


      <div className="d-flex flex-column" style={{ flexGrow:'1',width: "100%", backgroundColor: "#fff" }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                  General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                  Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                </a>
              </li>
             
            </ul>
             <Attachment doctype="Purchase Receipt"  docname={PurchaseData}  /> 

          </div>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px',flexGrow:'1' }}>
          {tab != 1 ? '' : <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 status={status} po={{ current_op: PurchaseData }} fulldata={fulldata} vendor={{ vendor: vendor }}   activityboll={activityboll}/>
          </div> }
          {tab != 1 ? '' : <div className="col-9 d-flex flex-column" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <div className="d-flex justify-content-between" style={{ gap: '5px' }}>
              <div className="d-flex mb-1" style={{ gap: '5px' }} >
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {fulldata?.message?.items?.length}</span></p>
                <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {fulldata?.message?.total_qty}</span></p>
                {/* <p className="ReceivedQty">Scanned Quantity -  <span style={{ color: '#EC642A' }}> {itemList.reduce((total, item) => { return total + Number(item?.accepted_qty); }, 0)}</span></p> */}
              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '99.6%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px',fontSize:'15px' }}>
                Item Details
              </p>
            </div>
            <Table
              // list_data={fulldata?.message?.items}
              list_data={itemList}
              fulldata={fulldata} row={{ Rows: item_Rows, setRows: setitem_Rows }} />
            <div className=" mt-auto pb-2" >
              <div className="row mt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ width: '20%' }}>
                  <p className="TotalQtywithoutBg">
                    Ordered Quantity -
                    <span style={{ color: '#EC642A' }}>
                      {fulldata?.message?.total_qty}
                    </span>
                  </p>
                </div>

                <div style={{ width: '18%' }}>
                  <p className="NoOfLinewithoutBg">
                    Total Value -
                    <span style={{ color: '#FF5969' }}>
                      {fulldata?.message?.total}
                    </span>
                  </p>
                </div>

                <div style={{ width: '24%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax Type -
                    <span style={{ color: '#C40AB8' }}>
                       IGST
                    </span>
                  </p>
                </div>

                <div style={{ width: '15%' }}>
                  <p className="NoOfLinewithoutBg">
                    Tax -
                    <span style={{ color: '#2563EB' }}>
                      {fulldata?.message?.total_taxes_and_charges}
                    </span>
                  </p>
                </div>
                <div style={{ width: '22%' }}>
                  <p className="NoOfLinewithoutBg">
                    Final Total -
                    <span style={{ color: '#16A34A' }}>
                     {fulldata?.message?.grand_total}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div> }
         {tab != 2 ? '' : <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}> <Tab2 status={status} vendor_address={{ vendor_address_list: vendor_address_list, setselect_vendor_address: setselect_vendor_address, currentAddress: select_vendor_address }} />   </div>} 
          
        </div>
      </div>


          {showPrintModal && (
                <PrintModal 
                    onClose={() => setShowPrintModal(false)}
                    documentId={PurchaseData}
                     doctype="Purchase Receipt"
                    title="Print GRN"
                />
            )}


      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default PurchaseReciept;
